import { api } from "./api"
import { Tutorial } from "types/tutorial"
import { dedupedFetch } from "./cache"

const getTutorial = async(tutorialId: string) =>{
    return dedupedFetch(`tutorial-${tutorialId}`, async () => {
        const {data} = await api.post('/find/tutorial_by_id', { id: tutorialId })

         if(!Array.isArray(data)){
            return [];
        }else{
            return data[0];
        }
    }, 120_000);
}

const getAllTutorials = async(): Promise<Tutorial[]> => {
    return dedupedFetch("tutorials", async () => {
        const {data} = await api.get<Tutorial[]>('/database/tutorial__c')
        return data;
    }, 300_000);
}

const getTutorialByTitle = async(title: string): Promise<Tutorial | null> => {
    try{
        const {data} = await api.post<Tutorial[]>('/find/tutorial_by_title', { title })

        if(!Array.isArray(data) || data.length === 0){
            return null;
        }
        return data[0];
    }catch(error:any){
        console.error('Erro ao buscar tutorial por título:', error);
        throw error;
    }
}

export {
    getTutorial,
    getAllTutorials,
    getTutorialByTitle
}